@for (toast of toasterService.toasts; track toast) {
  <ngb-toast
    [class]="toast.classname"
    [autohide]="true"
    [delay]="toast.delay || 5000"
    (hidden)="toasterService.remove(toast)"
  >
    {{ toast.text }}
  </ngb-toast>
}
